'use strict';

const translations = require('../../../data/translations.json');

module.exports = ['locale', locale => {
    function translate(key) {
        if (!translations[key]) {
            return false;
        }

        return translations[key][locale];
    }

    return {
        translate: translate
    }
}];



// WEBPACK FOOTER //
// ./widgets/services/translationService.js